<template>
  <BaseScreen name="home" class="homescreen">
    <div class="homescreen__hand homescreen__hand--thumbup"></div>
    <div class="homescreen__hand homescreen__hand--thumbdown"></div>
    <div class="homescreen__header">
      <TheHomeScreenGraphic />
      <h1 class="homescreen__title" v-content="title" />
      <p v-if="tagline" class="homescreen__tagline" v-content="tagline" />
    </div>
    <div class="homescreen__body">
      <BaseButton
        name="start"
        location="home"
        :is-primary="session.length > 0"
        is-large
        @click="clickStart"
        >{{ buttonText || $l10n("start") }}</BaseButton
      >
    </div>
  </BaseScreen>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    tagline: String,
    buttonText: String,
    outcomePlacement: String,
  },
  computed: {
    ...mapState(["session"]),
  },
  methods: {
    clickStart() {
      if (this.outcomePlacement === "start") {
        this.$emit("form", "start");
      } else {
        this.$emit("next");
      }
    },
  },
};
</script>
